import type { FC } from "react";

import Skeleton from "../SkeletonComponent/server/SkeletonComponent";

interface Props {
  isShowIcon?: boolean;
}

const SkeletonHeadingComponent: FC<Props> = ({ isShowIcon = false }) => {
  return (
    <div className="flex w-full items-center gap-2">
      {isShowIcon && (
        <Skeleton className="size-6 flex-none rounded-full md:size-8" />
      )}
      <div className="flex h-[26px] w-2/5 items-center md:h-[39px] md:w-1/4">
        <Skeleton className="h-4 w-full md:h-6" />
      </div>
    </div>
  );
};

export default SkeletonHeadingComponent;
